export enum PermissionProducts {
  Competitions = "competitions",
  TeamManager = "team-manager",
}
